import { Form, useFormikContext } from 'formik';

import { Button } from '../../../../cdl/Button/Button';
import { Callout } from '../../../../cdl/Callout/Callout';
import { FormikCheckbox } from '../../../../cdl/Checkbox/FormikCheckbox';
import { DrawerContentLayout } from '../../../../cdl/Drawer/DrawerContentLayout';
import { FormikInput } from '../../../../cdl/Input/FormikInput';
import { Text } from '../../../../cdl/Text/Text';
import { FormikDebug } from '../../../../common/form-elements/formik/FormikDebug';
import { translate } from '../../../../common/helpers/translate.helper';
import { useRole } from '../../../../common/hooks/useRole';
import { IconInfoCircle } from '../../../../common/icons/cdl/InfoCircle';
import { Box } from '../../../../common/ui/Box';

import { FormikSupplierCreateState } from './CreateSupplierCompanyForm';

export const FormikCreateSupplierCompanyForm = () => {
    const { isSubmitting, dirty } = useFormikContext<FormikSupplierCreateState>();
    const role = useRole();

    return (
        <Form style={{ height: '100%', minHeight: 0 }}>
            <DrawerContentLayout
                isBusy={isSubmitting}
                hasUnsavedChanges={dirty}
                primaryAction={
                    <Button type="submit" emphasis="high" isLoading={isSubmitting}>
                        {translate('supplier.createCompany')}
                    </Button>
                }
            >
                <Text variant="subtitle1">{translate('company.companyInformation')}</Text>

                <FormikInput name="name" label={translate('company.name')} markAsRequired />
                <FormikInput
                    name="internalName"
                    label={translate('company.internalName')}
                    caption={translate('company.internalName.caption')}
                    CaptionIcon={IconInfoCircle}
                />
                <FormikInput name="email" label={translate('company.email')} markAsRequired />
                <FormikInput name="phone" label={translate('company.phone')} />
                <FormikInput name="fax" label={translate('company.fax')} />
                <FormikInput name="invoiceMail" label={translate('global.contact.invoicemail')} />

                <Text variant="subtitle1" marginTop={16}>
                    {translate('company.address')}
                </Text>

                <FormikInput name="address.companyName" label={translate('company.name')} />
                <Box display="grid" gridTemplateColumns="2fr 1fr" columnGap={16}>
                    <FormikInput name="address.street" label={translate('global.address.street')} />
                    <FormikInput name="address.streetNumber" label={translate('global.address.streetnumber')} />
                </Box>
                <Box display="grid" gridTemplateColumns="1fr 2fr" columnGap={16}>
                    <FormikInput name="address.zipcode" label={translate('global.address.zipcode')} />
                    <FormikInput name="address.city" label={translate('global.address.city')} />
                </Box>
                <FormikInput name="address.country" label={translate('global.address.country')} />

                {role.isSuperAdmin() ? (
                    <Box marginTop={16} display="flex" flexDirection="column" alignItems="left" rowGap={8}>
                        <Text variant="subtitle1">{translate('company.settings')}</Text>

                        <FormikCheckbox name="testCompany" label={translate('company.testCompany')} />
                        <FormikCheckbox name="trial" label={translate('company.trial')} />
                        <FormikCheckbox
                            name="showGtc"
                            label={translate('company.showGtc')}
                            description={translate('supplier.showGtcDescription')}
                        />
                    </Box>
                ) : null}

                <Box paddingY={8}>
                    <Callout
                        variant="accent"
                        description={translate('supplier.messageSettings.explanation')}
                        Icon={IconInfoCircle}
                    />
                </Box>

                <FormikInput
                    name="messageSettings.orderConfirmationMessage"
                    label={translate('supplier.messageSettings.orderConfirmationMessageLabel')}
                />
                <FormikInput
                    name="messageSettings.quotationMessage"
                    label={translate('supplier.messageSettings.quotationMessageLabel')}
                />
                <FormikDebug />
            </DrawerContentLayout>
        </Form>
    );
};
